// firebase settings
const firebaseConfig = {
  apiKey: "AIzaSyAOAS3LvkeEUWZ_ZTy719YEnFTRfX__aBU",
  authDomain: "llabs-rkms.firebaseapp.com",
  databaseURL: "https://llabs-rkms.firebaseio.com",
  projectId: "llabs-rkms",
  storageBucket: "llabs-rkms.appspot.com",
  messagingSenderId: "649890870411",
  appId: "1:649890870411:web:ef720878ed344793c2108e"
};
// spreadsheet JSON API settings
const spreadsheetConfig = {
  url: "https://script.google.com/macros/s/AKfycbz8AlIUZAnpHvC4-QB2r_40ASAf1MnIg0SqFmrVwOhhq8yr6ow/exec"
};

export { firebaseConfig, spreadsheetConfig }
